var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirdropSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 1.75,
    width: 15,
    height: 15,
    rx: 1,
    stroke: "#B0E577",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.75 16.75C35.8921 16.75 39.25 13.3921 39.25 9.25C39.25 5.10786 35.8921 1.75 31.75 1.75C27.6079 1.75 24.25 5.10786 24.25 9.25C24.25 13.3921 27.6079 16.75 31.75 16.75Z",
    stroke: "#B0E577",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8098 23.7952C31.5556 23.3065 31.0506 23 30.4998 23C29.949 23 29.444 23.3065 29.1898 23.7952L21.9615 36.8068C21.6837 37.3124 21.6793 37.924 21.9498 38.4335C22.2055 38.9291 22.7138 39.2432 23.2715 39.2502H37.7281C38.2858 39.2432 38.7941 38.9291 39.0498 38.4335C39.3203 37.924 39.3159 37.3124 39.0381 36.8068L31.8098 23.7952Z",
    stroke: "#B0E577",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2522 22.2232C10.0059 21.9248 9.63915 21.752 9.2522 21.752C8.86525 21.752 8.49853 21.9248 8.2522 22.2232L2.06887 29.6182C1.64371 30.1291 1.64371 30.8706 2.06887 31.3815L8.24887 38.7765C8.49519 39.0749 8.86192 39.2477 9.24887 39.2477C9.63582 39.2477 10.0025 39.0749 10.2489 38.7765L16.4289 31.3815C16.854 30.8706 16.854 30.1291 16.4289 29.6182L10.2522 22.2232Z",
    stroke: "#B0E577",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirdropSearchIcon);
export default __webpack_public_path__ + "static/media/airdropSearchIcon.05f145c9ed7388068bf5acd21aab328f.svg";
export { ForwardRef as ReactComponent };